/**
 * The share view's ONE Bin-restore request. E7 PR 0b: no automatic retry (owner, option B) — a 503
 * `ENGINE_DB_VERIFYING` is handed back like any answer and the caller says "try again in a moment". `signal` is the
 * session's (`sessionSignal()`): the visit ending aborts the request in flight (an `AbortError`); never in the body.
 */
import { getApiBase } from '@papan/api-client'
import { shareWriteFetch } from './AttributionDisclosure'

export function restoreShareBinEntry(sessionId: string, binId: string, targetParentId?: string, signal?: AbortSignal): Promise<Response> {
  return shareWriteFetch(sessionId, `${getApiBase()}/api/share-links/session/${sessionId}/bin/${encodeURIComponent(binId)}/restore`, {
    method: 'POST',
    credentials: 'include',
    ...(signal ? { signal } : {}),
    ...(targetParentId !== undefined
      ? { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ targetParentId }) }
      : {}),
  })
}
